export const FETCH_SAMPLES_LIST = "FETCH_SAMPLES_LIST"
export const FETCH_LOCATIONS_LIST = "FETCH_LOCATIONS_LIST"
export const DELETE_SAMPLE = "DELETE_SAMPLE"
export const DELETE_MULTIPLE_SAMPLES = "DELETE_MULTIPLE_SAMPLES"
export const SAVE_SAMPLE = "SAVE_SAMPLE"
export const MODIFY_SAMPLE_DATA = "MODIFY_SAMPLE_DATA"
export const FETCH_LOCATIONS_DATA = "FETCH_LOCATIONS_DATA"
export const FETCH_RESULTS_LIST = "FETCH_RESULTS_LIST"
export const DELETE_RESULT = "DELETE_RESULT"
export const DELETE_MULTIPLE_RESULTS = "DELETE_MULTIPLE_RESULTS"
export const FETCH_FILTER_OPTIONS = 'FETCH_FILTER_OPTIONS'
export const FETCH_BUILDINGS_LIST = "FETCH_BUILDINGS_LIST"
export const SAVE_BUILDING = "SAVE_BUILDING"
export const DELETE_BUILDING = "DELETE_BUILDING"
export const FETCH_FLOORS_LIST = "FETCH_FLOORS_LIST"
export const FETCH_FLOOR_LIST = "FETCH_FLOOR_LIST"
export const FETCH_FLOOR_PLAN = "FETCH_FLOOR_PLAN"
export const DELETE_FLOOR = "DELETE_FLOOR"
export const SAVE_FLOOR = "SAVE_FLOOR"
export const INITIAL_RESULT_STATE_DATA = "INITIAL_RESULT_STATE_DATA"
export const FETCH_ROOMS_LIST = "FETCH_ROOMS_LIST"
export const FETCH_ROOM_LIST = "FETCH_ROOM_LIST"
export const DELETE_ROOM = "DELETE_ROOM"
export const SAVE_ROOM = "SAVE_ROOM"
export const FETCH_COMPLEX_TYPE = "FETCH_COMPLEX_TYPE"
export const FETCH_SPECIES_TYPE = "FETCH_SPECIES_TYPE"
export const UPDATE_RESULT_STATE = "UPDATE_RESULT_STATE"
export const UPDATE_RESULT_STATE_FILTERS = "UPDATE_RESULT_STATE_FILTERS"
export const INITIAL_LOCATION_STATE_DATA = "INITIAL_LOCATION_STATE_DATA"
export const UPDATE_LOCATION_STATE = "UPDATE_LOCATION_STATE"
export const UPDATE_LOCATION_STATE_FILTERS = "UPDATE_LOCATION_STATE_FILTERS"
export const FETCH_LOCATION_DATA = "FETCH_LOCATION_DATA"
export const FETCH_SAMPLE_DATA = "FETCH_SAMPLE_DATA"
export const FETCH_RESULT_DATA = "FETCH_RESULT_DATA"
export const FETCH_RESULT_BIOME_DATA = "FETCH_RESULT_BIOME_DATA"
export const UPLOAD_RESULT_DATA="UPLOAD_RESULT_DATA"
export const UPLOAD_SAMPLE_DATA="UPLOAD_SAMPLE_DATA"
export const FETCH_DASHBORD_DATA="FETCH_DASHBORD_DATA"
export const FETCH_NOTIFICATIONS_LIST = "FETCH_NOTIFICATIONS_LIST"
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const SAVE_NOTIFICATION = "SAVE_NOTIFICATION"
export const MODIFY_NOTIFICATION_DATA = "MODIFY_NOTIFICATIONS_DATA"
export const FETCH_NOTIFICATION_DATA = "FETCH_NOTIFICATION_DATA"
export const DELETE_MULTIPLE_NOTIFICATIONS = "DELETE_MULTIPLE_NOTIFICATIONS"
export const MODIFY_RECURRENT_NOTIFICATIONS_DATA = "MODIFY_RECURRENT_NOTIFICATIONS_DATA"
export const FETCH_BATCH_NUMBERS = "FETCH_BATCH_NUMBERS"
export const SEND_EMAIL = "SEND_EMAIL"
export const DELETE_MULTIPLE_LOCATIONS = "DELETE_MULTIPLE_LOCATIONS"
export const SAVE_WIKI_DATA = "SAVE_WIKI_DATA"
export const FETCH_WIKI_DATA = "FETCH_WIKI_DATA"
export const MODIFY_WIKI_DATA = "MODIFY_WIKI_DATA"
export const DELETE_WIKI_DATA = "DELETE_WIKI_DATA"
export const SAVE_ANNOUNCEMENTS_DATA = "SAVE_ANNOUNCEMENTS_DATA"
export const GET_ANNOUNCEMENTS_DATA = "GET_ANNOUNCEMENTS_DATA"
export const SAVE_USER_PROFILE_DATA = "SAVE_USER_PROFILE_DATA"
export const FETCH_USER_PROFILE_DATA = "FETCH_USER_PROFILE_DATA"
export const UPDATE_USER_PROFILE_DATA = "UPDATE_USER_PROFILE_DATA"
export const SAVE_LAB_DATA = "SAVE_LAB_DATA"
export const FETCH_LOCATION_TREND_DATA = "FETCH LOCATION TREND DATA"